export default {
    methods: {
        convertToExcel(invalidRows: any) {
            const result = [] as any[];
            invalidRows.forEach((invalidRow: any) => {
                const row = {} as any;
            
                row["Row #"] = invalidRow.rowNum;
                if (Object.keys(invalidRow.items).length > 0) {
                    Object.keys(invalidRow.items).forEach((itemKey) => {
                        row[itemKey] = invalidRow.items[itemKey];
                    });
                }
                row["Type"] = invalidRow.type;
                row["Remark"] = invalidRow.remarks;
                result.push(row);
            });
            return result;
        }
    }
}